import ease from "ease-component";
import scroll from "scroll";

export default class Scroll
{
	constructor(el)
	{
		this.el = el;
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`[data-scroll-top]`)) {
				event.preventDefault();
				new this(document.querySelector(event.target.dataset.scrollTop)).top();
			}
		}, {
			capture: true,
		});
	}

	top()
	{
		scroll.top(document.querySelector("html"), this.el.offsetTop, {
			duration: 750,
			ease: ease.inOutSine,
		});
	}
}
